import React from "react";
import { useDispatch } from 'react-redux';
// import { loginMiddleware } from '../../store/middleware/loginMiddleware';
import { Col, Form, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AntdDropdown, AntdInput, AntdPassInput, AntdSubmit } from "../../components";
import AlertAction from "../../store/Actions/AlertActions";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
import styles from "./Login.module.css";
const Login = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  //login functions
  const onFinish = (values) => {
    console.log('Success values:', values);
    if (!values.email || !values.password) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All fields required' }))
    } else if (!values.role) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Please select user role' }))
    } else {
      dispatch(AuthMiddleware.Login(values))
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    // dispatch(AlertAction.ShowAlert({ type: "warning", message: errorInfo[0].message }))
  };
  const [form] = Form.useForm();
  const handleChange = value => {
    form.setFieldsValue({ role: value });
  };
  return (
    <div className={styles.mainCon}>

      <Row className={styles.subMainCon}>
        <Col className={styles.leftCol}></Col>
        <Col className={styles.rightCol} >
          <div className={styles.loginFormCont}>
            <div className={styles.login_heading}>
              <h1>Login</h1>
            </div>
            <div style={{ width: '100%' }}>
              <Form
                name="basic"
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <AntdInput placeholder={"John@gmail.com"} name={'email'} label='Email' rules={[{ require: true, type: 'email', message: 'Please enter valid email' }]} />
                <AntdPassInput placeholder={"********"} name={'password'} label='Password' rules={[{ require: true, type: 'text', message: 'Please enter your password' },]} />
                <div className={styles.forgotPassDiv} >
                  <p className={styles.forgotPassText} onClick={() => navigate('/forgetPassword')}>Forgot Password?</p>
                </div>
                <AntdDropdown
                  placeholder={"Select role"}
                  name={'role'}
                  label={'Role'}
                  onChange={handleChange}
                  options={[
                    { value: 'customer', option: 'Customer' },
                    { value: 'cleaner', option: 'Cleaner' },
                    { value: 'contractor', option: 'Contractor' }]}
                />
                <AntdSubmit text={'Login'} buttonStyle={{ margin: '30px 0px' }} />
              </Form>
              <p style={{ color: 'var(--white-color)', fontSize: '16px', cursor: 'pointer' }} >If You Are Unable To Sign In? Please <span onClick={() => navigate('/signup')} style={{ color: 'var(--secondary-color)' }}>Create Account</span> </p>
            </div>
          </div>
        </Col>


      </Row>

    </div>
  );
};

export default Login;
